@if (collapsed()) {
  <li class="relative">
    @if (item().externalUrl !== undefined) {
      <a
        #itemLink
        [attr.href]="item().isDisabled ? null : item().externalUrl"
        target="_blank"
        rel="noopener noreferrer"
        [class.pointer-events-none]="item().isDisabled"
        [class.opacity-50]="item().isDisabled"
        [class.cursor-not-allowed]="item().isDisabled"
        class="group relative flex w-full items-center justify-center rounded-lg p-2">
        <span
          class="group-hover:bg-accent-interactive-hover absolute top-2 bottom-2 -left-1 w-1 min-w-1 rounded-full transition-all"></span>
        <i [class]="item().iconClass" class="text-text-primary text-base"></i>
      </a>
      <app-tooltip [target]="itemLink" [content]="label()" position="right" />
    } @else {
      <a
        #itemLink
        [routerLinkActive]="
          item().isDisabled ? '' : 'active bg-accent-interactive text-text-primary'
        "
        [routerLinkActiveOptions]="item().routerLinkActiveOptions ?? { exact: false }"
        [routerLink]="item().isDisabled ? null : item().route"
        [class.pointer-events-none]="item().isDisabled"
        [class.opacity-50]="item().isDisabled"
        [class.cursor-not-allowed]="item().isDisabled"
        class="group relative flex w-full items-center justify-center rounded-lg p-2">
        <span
          [routerLinkActive]="
            item().isDisabled ? '' : 'bg-accent-main group-hover:bg-accent-main'
          "
          [routerLinkActiveOptions]="item().routerLinkActiveOptions ?? { exact: false }"
          class="group-hover:bg-accent-interactive-hover absolute top-2 bottom-2 -left-1 w-1 min-w-1 rounded-full transition-all"></span>
        <i
          [routerLinkActive]="item().isDisabled ? '' : 'dark:text-accent-main'"
          [routerLinkActiveOptions]="item().routerLinkActiveOptions ?? { exact: false }"
          [class]="item().iconClass"
          class="text-text-primary text-base"></i>
      </a>
      <app-tooltip [target]="itemLink" [content]="label()" position="right" />
    }
  </li>
} @else {
  <li class="relative">
    @if (item().externalUrl !== undefined) {
      <a
        [attr.href]="item().isDisabled ? null : item().externalUrl"
        target="_blank"
        rel="noopener noreferrer"
        [class.pointer-events-none]="item().isDisabled"
        [class.opacity-50]="item().isDisabled"
        [class.cursor-not-allowed]="item().isDisabled"
        class="group relative flex w-full items-center gap-2 rounded-lg px-2 py-1.5">
        <span
          class="group-hover:bg-accent-interactive-hover absolute top-2 bottom-2 -left-1 w-1 min-w-1 rounded-full transition-all"></span>
        <i [class]="item().iconClass" class="text-text-primary text-base"></i>
        <div class="flex w-full items-center text-sm font-semibold">
          {{ label() }}
        </div>
      </a>
    } @else {
      <a
        [routerLinkActive]="
          item().isDisabled ? '' : 'active bg-accent-interactive text-text-primary'
        "
        [routerLinkActiveOptions]="item().routerLinkActiveOptions ?? { exact: false }"
        [routerLink]="item().isDisabled ? null : item().route"
        [class.pointer-events-none]="item().isDisabled"
        [class.opacity-50]="item().isDisabled"
        [class.cursor-not-allowed]="item().isDisabled"
        class="group relative flex w-full items-center gap-2 rounded-lg px-2 py-1.5">
        <span
          [routerLinkActive]="
            item().isDisabled ? '' : 'bg-accent-main group-hover:bg-accent-main'
          "
          [routerLinkActiveOptions]="item().routerLinkActiveOptions ?? { exact: false }"
          class="group-hover:bg-accent-interactive-hover absolute top-2 bottom-2 -left-1 w-1 min-w-1 rounded-full transition-all"></span>
        <i
          [routerLinkActive]="item().isDisabled ? '' : 'dark:text-accent-main'"
          [routerLinkActiveOptions]="item().routerLinkActiveOptions ?? { exact: false }"
          [class]="item().iconClass"
          class="text-text-primary text-base"></i>
        <div class="flex w-full items-center text-sm font-semibold">
          {{ label() }}
        </div>
        @if (item().shortcut) {
          <span
            class="absolute top-0 right-0 bottom-0 hidden items-center opacity-0 transition-opacity group-hover:opacity-100 md:flex">
            <span
              class="to-page group-[.active]:to-accent-interactive pointer-events-none h-full w-8 bg-linear-to-r from-transparent"></span>
            <span
              class="bg-page text-text-tertiary group-[.active]:bg-accent-interactive pr-3 text-sm">
              {{ item().shortcut }}
            </span>
          </span>
        }
      </a>
    }
  </li>
}
